/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_TruncatedInputs */

const en_issue_truncated = /** @type {(inputs: Issue_TruncatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cut to the length of the column of the file to the ERP`)
};

/**
* | output |
* | --- |
* | "cut to the length of the column of the file to the ERP" |
*
* @param {Issue_TruncatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_truncated = /** @type {((inputs?: Issue_TruncatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_TruncatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_truncated(inputs)
});